module.exports = __webpack_public_path__ + "static/media/copy-text.164c6ea6.svg";